<div class="webinar swiper-no-swiping">
    <div class="row">
        <div class="text" [innerHTML]="title | safeHtml"></div>
        <button (click)="onClick($event)">{{'__JOURNEY_WEBINAR_BUTTON__' | translate}}</button>
    </div>
</div>
